AuthRoute          = require 'mixins/authenticated-route'
TeardownController = require 'mixins/teardown-controller'

App.DeliveryCouriersCreateRoute = Em.Route.extend [
  AuthRoute,
  TeardownController
]...,
  controllerName: 'deliveryCouriersEdit'
  templateName:   'delivery.couriers.edit'

  model: ->
    model = @store.createRecord 'courier',
      name: Em.I18n.t('courier.new')

  afterModel: (model) ->
    new Em.RSVP.Promise (resolve, reject) =>
      user = @get('session').get('currentUser')

      if user.get('isPartner')
        user.get('account').get('partnership').then (partnership) =>
          model.set('partnership', partnership)
          return resolve(model)

      if user.get('isLogisticsStaff')
        model.set('logistics_center', @get('session.currentLogisticsCenter'))
        return resolve(model)

      if user.get('isStaffMember')
        model.set('organization', @get('session').get('currentOrganization'))
        return resolve(model)
